module.exports = __webpack_public_path__ + "static/scale-model-of-cedar-rapids-museum-of-art-in-cedar-rapids-iowa-1b7f8e3dfc18a1454c2fd799ad3502d2.png";